import classNames from 'classnames/bind';
import styles from './Information.module.css';

import {
  CONTACT_US,
  INACTIVE_ACCOUNT_INFO,
  PREV,
  RECOVER_ACCOUNT,
} from '../../../constants';
import { useNavigate } from 'react-router-dom';
import { LoginResData } from '../../../types/login';

interface Info {
  title: string;
  info: LoginResData;
  children: React.ReactNode[];
}

export default function Information({ title, info, children }: Info) {
  const cx = classNames.bind(styles);
  const navigate = useNavigate();
  const [TopDescription, Info, BottomDescription] = children;

  const movePage = ({ target }: React.MouseEvent<HTMLButtonElement>) => {
    const path =
      (target as HTMLButtonElement).textContent === RECOVER_ACCOUNT
        ? 'recovery'
        : 'contact';
    navigate(`../${path}`, { state: { info: info } });
  };

  return (
    <>
      <h2>{title}</h2>
      <div>
        <div className={cx('info_account')}>
          <p className={cx('desc')}>{TopDescription}</p>
          <div className={cx('info_box')}>{Info}</div>
          <p className={cx('desc', 'mx')}>{BottomDescription}</p>
        </div>

        <div className={cx('btn_wrap', 'bottom', 'cell')}>
          <button
            type="button"
            className={cx('btn', 'b_t', 'dull', 's44')}
            onClick={() => navigate('../')}
          >
            <span>{PREV}</span>
          </button>
          <button
            type="button"
            className={cx('btn', 'b_t', 's44')}
            onClick={movePage}
          >
            <span>
              {title === INACTIVE_ACCOUNT_INFO ? RECOVER_ACCOUNT : CONTACT_US}
            </span>
          </button>
        </div>
      </div>
    </>
  );
}
